import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/new-content/outils-excel.png'
import _imports_1 from '@/assets/stock/plus-gris-add.png'
import _imports_2 from '@/assets/stock/plus-orange-add.png'


const _withScopeId = n => (_pushScopeId("data-v-458eedb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-container vld-parent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, null, -1))
const _hoisted_3 = { colspan: "4" }
const _hoisted_4 = { rowspan: "2" }
const _hoisted_5 = { colspan: "2" }
const _hoisted_6 = { rowspan: "2" }
const _hoisted_7 = { rowspan: "2" }
const _hoisted_8 = { rowspan: "2" }
const _hoisted_9 = { rowspan: "2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 1,
  class: "button-disabled",
  src: _imports_1
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "button-disabled",
  src: _imports_1
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "button-disabled",
    src: _imports_1
  })
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorModal = _resolveComponent("ErrorModal")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.errorModalOpen)
      ? (_openBlock(), _createBlock(_component_ErrorModal, {
          key: 0,
          messages: $setup.errorMessage || [$setup.t('generic.error')],
          onClose: $setup.CloseErrorModal
        }, null, 8, ["messages", "onClose"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: $setup.isLoading,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.isLoading) = $event)),
        "can-cancel": false,
        "is-full-page": true
      }, null, 8, ["active"]),
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_2,
            _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('components.stock.global.numberOfData')), 1),
            _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('components.stock.global.lastAddedDate')), 1),
            _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('components.stock.global.numberOfDataAdded')), 1),
            _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('generic.evolution')), 1),
            _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('components.stock.global.parameterizedFile')), 1),
            _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('components.stock.global.dataManagement')), 1),
            _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('components.stock.global.designManagement')), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_10,
            _createElementVNode("th", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.ToggleSort('domain', $setup.toggleSort))),
              class: "cursor-pointer"
            }, _toDisplayString(_ctx.$t('components.stock.global.domain')), 1),
            _createElementVNode("th", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.ToggleSort('activity', $setup.toggleSort))),
              class: "cursor-pointer"
            }, _toDisplayString(_ctx.$t('components.stock.global.activity')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('generic.easy')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('generic.medium')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('generic.difficult')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('generic.global')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.stock.global.on3Months')), 1),
            _createElementVNode("th", null, _toDisplayString(_ctx.$t('components.stock.global.on12Months')), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rows, (row) => {
            return (_openBlock(), _createElementBlock("tr", { key: row }, [
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  style: _normalizeStyle({ backgroundColor: row.domcolor })
                }, null, 4)
              ]),
              _createElementVNode("td", null, _toDisplayString(row.domain), 1),
              _createElementVNode("td", null, _toDisplayString(row.activity), 1),
              _createElementVNode("td", null, _toDisplayString(row.easy), 1),
              _createElementVNode("td", null, _toDisplayString(row.medium), 1),
              _createElementVNode("td", null, _toDisplayString(row.hard), 1),
              _createElementVNode("td", null, _toDisplayString(row.global), 1),
              (row.datalastmodified)
                ? (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString($setup.convertDate(row.datalastmodified)), 1))
                : (_openBlock(), _createElementBlock("td", _hoisted_12, "/")),
              _createElementVNode("td", null, _toDisplayString(row.threemonthsdata), 1),
              _createElementVNode("td", null, _toDisplayString(row.oneyeardata), 1),
              _createElementVNode("td", null, [
                _createElementVNode("img", {
                  src: $setup.GetArrowIcons(row.threemonthsdata, row.oneyeardata)
                }, null, 8, _hoisted_13)
              ]),
              _createElementVNode("td", null, [
                (row.hastemplate)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _imports_0,
                      class: "excel-icon cursor-pointer",
                      onClick: ($event: any) => ($setup.DownloadFile(row.actid, row.activity + '.xlsx'))
                    }, null, 8, _hoisted_14))
                  : (_openBlock(), _createElementBlock("img", _hoisted_15))
              ]),
              _createElementVNode("td", null, [
                (row.hastemplate)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      onClick: ($event: any) => ($props.openActivityPage(row.actid, row.domain, row.activity)),
                      src: _imports_2,
                      class: "cursor-pointer add-icon"
                    }, null, 8, _hoisted_16))
                  : (_openBlock(), _createElementBlock("img", _hoisted_17))
              ]),
              _hoisted_18
            ]))
          }), 128))
        ]),
        _createElementVNode("tfoot", null, [
          _createElementVNode("tr", null, [
            _hoisted_19,
            _createElementVNode("th", null, _toDisplayString($setup.easyDataCount), 1),
            _createElementVNode("th", null, _toDisplayString($setup.mediumDataCount), 1),
            _createElementVNode("th", null, _toDisplayString($setup.hardDataCount), 1),
            _createElementVNode("th", null, _toDisplayString($setup.globalDataCount), 1),
            _hoisted_20,
            _createElementVNode("th", null, _toDisplayString($setup.totalThreeMonthsDataCount), 1),
            _createElementVNode("th", null, _toDisplayString($setup.totalOneYearDataCount), 1),
            _hoisted_21
          ])
        ])
      ])
    ])
  ], 64))
}